import { all } from 'redux-saga/effects';

import consultaCnhDefinitivaSaga from './consultaCnhDefinitiva/saga';

export default all([consultaCnhDefinitivaSaga]);
